import React, { useState, useEffect, useRef } from "react";
import ProductModal from "./ProductModal";
import Button from "@mui/material/Button";
import { useTheme } from "../context/ThemeContext";
// import NewOrderDrawingModal from "./NewOrderDrawingModal";
import NewOrderItemsTable from "./NewOrderItemsTable";
import NewOrderForm from "./NewOrderForm";
import API_BASE_URL from "../config";

const NewOrderModal = ({ isOpen, onClose, fetchOrders, selectedYear, customers = [] }) => {
  const [customerId, setCustomerId] = useState("");
  const [street, setStreet] = useState("");
  const [orderItems, setOrderItems] = useState([]);
  // const [drawingData, setDrawingData] = useState("");
  const [orderNumber, setOrderNumber] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  // const [isDrawingModalOpen, setIsDrawingModalOpen] = useState(false);
  const [isProductModalOpen, setIsProductModalOpen] = useState(false);
  const { darkMode } = useTheme();
  const [products, setProducts] = useState([]);
  const [discountPercentage, setDiscountPercentage] = useState(0);
  const [preferentialPrice, setPreferentialPrice] = useState(0);
  const [isAdvanceOrder, setIsAdvanceOrder] = useState(false);
  const [isGranitOnline, setIsGranitOnline] = useState(false);
  const [customerSource, setCustomerSource] = useState(null);

  const [newProduct, setNewProduct] = useState({
    materialName: "",
    quantityMP: "",
    quantityML: "",
    bizot: "",
  });

  // const signatureRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      resetFields();
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      fetchNextOrderNumber();
    }
  }, [isOpen, isGranitOnline]);

  const fetchNextOrderNumber = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${API_BASE_URL}/api/orders/next-order-number?isGranitOnline=${isGranitOnline}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (!response.ok)
        throw new Error("Eroare la obținerea numărului comenzii.");

      const data = await response.json();
      setOrderNumber(data);
    } catch (err) {
      setError(err.message);
    }
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(`${API_BASE_URL}/api/products`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await response.json();
        setProducts(data);
      } catch (err) {
        console.error("❌ Nem sikerült betölteni a termékeket:", err);
      }
    };

    if (isOpen) {
      fetchProducts();
    }
  }, [isOpen]);

  // useEffect(() => {
  //   if (isDrawingModalOpen && signatureRef.current && drawingData) {
  //     signatureRef.current.fromDataURL(drawingData);
  //   }
  // }, [isDrawingModalOpen, drawingData]);

  const resetFields = () => {
    setCustomerId("");
    setStreet("");
    setIsGranitOnline(false);
    setCustomerSource(null);
    setOrderItems([
      {
        productId: "",
        materialName: "",
        length: "",
        width: "",
        quantity: "",
        quantityMP: "",
        quantityML: "",
        quantityBUC: "",
        bizot: "",
        isManualMP: false,
      },
    ]);
    // setDrawingData("");
    // if (signatureRef.current) signatureRef.current.clear();
    setError(null);
  };

  const handleAddProduct = () => {
    if (
      !newProduct.productId ||
      Number(newProduct.quantityMP) < 0 ||
      Number(newProduct.quantityML) < 0
    ) {
      setError("Toate câmpurile produsului trebuie completate corect.");
      return;
    }

    const productToSend = {
      productId: newProduct.productId,
      materialName: newProduct.materialName,
      price: newProduct.price,
      quantityMP: parseFloat(newProduct.quantityMP) || 0,
      quantityML: parseFloat(newProduct.quantityML) || 0,
      bizot: newProduct.bizot,
      length: parseFloat(newProduct.length) || 0, // 🔥 Hossz mentése
      width: parseFloat(newProduct.width) || 0, // 🔥 Szélesség mentése
      quantity: parseInt(newProduct.quantity, 10) || 0, // 🔥 Mennyiség mentése
    };

    setOrderItems([...orderItems, productToSend]);

    setNewProduct({
      productId: "",
      materialName: "",
      quantityMP: "",
      quantityML: "",
      bizot: "",
      price: "",
      length: "",
      width: "",
      quantity: "",
    });

    setIsProductModalOpen(false);
  };

  const removeOrderItem = (index) => {
    setOrderItems(orderItems.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccessMessage("");

    if (!customerId || orderItems.length === 0) {
      setError("Trebuie selectat un client și adăugat cel puțin un produs.");
      setLoading(false);
      return;
    }



    // Előtte szedd ki a customerType-ot:
    const currentCustomer = customers.find(c => c.id === Number(customerId));
    const customerType = currentCustomer ? currentCustomer.type : 0; // 0 = Final, 1 = Marmurist

    // Ellenőrizd, hogy bármelyik termék ára 0-e!
    const hasZeroPricedProduct = orderItems.some(item => {
      const dbProduct = products.find(p => p.id === Number(item.productId));
      if (!dbProduct) return false;
      if (customerType === 1) {
        return !dbProduct.priceMarmurist || Number(dbProduct.priceMarmurist) <= 0;
      }
      return !dbProduct.price || Number(dbProduct.price) <= 0;
    });

    if (hasZeroPricedProduct) {
      setError("❌ Nu se poate plasa o comandă cu un produs cu preț 0!");
      setLoading(false);
      return;
    }


    if (
      orderItems.some(
        (item) =>
          item.quantityBUC !== "" && !Number.isInteger(Number(item.quantityBUC))
      )
    ) {
      setError("❌ Toate valorile BUC trebuie să fie numere întregi!");
      setLoading(false);
      return;
    }

    if (orderItems.some((item) => !item.productId)) {
      setError("Toate produsele trebuie să aibă un material selectat.");
      setLoading(false);
      return;
    }

    const requestData = {
      customerId: Number(customerId),
      orderItems: orderItems.map((item) => ({
        productId: Number(item.productId),
        materialName: item.materialName || "",
        length: item.length !== "" ? parseFloat(item.length) : 0,
        width: item.width !== "" ? parseFloat(item.width) : 0,
        quantity: item.quantity !== "" ? parseInt(item.quantity) : 0,
        quantityMP: item.quantityMP !== "" ? parseFloat(item.quantityMP) : 0,
        quantityML: item.quantityML !== "" ? parseFloat(item.quantityML) : 0,
        quantityBUC: item.quantityBUC !== "" ? parseFloat(item.quantityBUC) : 0,
        bizot: item.bizot || "",
      })),

      discountPercentage,
      preferentialPrice,
      isAdvanceOrder,
      isGranitOnline,
      customerSource: customerSource ?? 0
    };

    if (street.trim()) {
      requestData.street = street.trim();
    }

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_BASE_URL}/api/orders`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(JSON.stringify(errorData, null, 2));
      }

      fetchOrders(selectedYear);
      setSuccessMessage("✅ Comanda a fost adăugată cu succes!");

      setTimeout(() => {
        setSuccessMessage("");
        onClose();
      }, 1000);
    } catch (err) {
      console.error("❌ Hiba a rendelés mentésekor:", err);

      try {
        const errorObj = JSON.parse(err.message);
        if (
          errorObj.details &&
          errorObj.details.includes("Nincs elegendő készlet")
        ) {
          setError(
            "❌ Nu există suficient stoc pentru unele produse! Verifică cantitățile."
          );
        } else {
          setError(
            errorObj.message || "❌ Eroare necunoscută la salvarea comenzii."
          );
        }
      } catch (parseError) {
        setError("❌ Eroare la salvarea comenzii. Încearcă din nou.");
      }
    } finally {
      setLoading(false);
    }
  };

  return isOpen ? (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div
        className={`p-6 rounded-3xl shadow-xl w-[1200px] max-h-[95vh] overflow-y-auto relative transition-colors ${darkMode ? "bg-gray-900 text-white" : "bg-white text-gray-900"
          }`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Bezárás gomb */}
        <button
          onClick={onClose}
          className={`absolute top-3 right-4 text-2xl ${darkMode
            ? "text-red-400 hover:text-red-600"
            : "text-red-500 hover:text-red-700"
            }`}
        >
          ✖
        </button>

        <h2
          className={`text-2xl font-semibold mb-4 text-center ${darkMode ? "text-blue-400" : "text-blue-600"
            }`}
        >
          Adăugare Comandă Nouă - Nr. Comandă #{orderNumber}
        </h2>

        {successMessage && (
          <p
            className={`p-2 rounded mb-3 text-center ${darkMode
              ? "text-green-400 bg-green-900"
              : "text-green-700 bg-green-200"
              }`}
          >
            {successMessage}
          </p>
        )}
        {error && (
          <p
            className={`p-2 rounded mb-3 text-center ${darkMode ? "text-red-400 bg-red-900" : "text-red-700 bg-red-200"
              }`}
          >
            {error}
          </p>
        )}

        <NewOrderForm
          orderNumber={orderNumber}
          customerId={customerId}
          setCustomerId={setCustomerId}
          customers={customers}
          street={street}
          setStreet={setStreet}
          orderItems={orderItems}
          setIsProductModalOpen={setIsProductModalOpen}
          // setIsDrawingModalOpen={setIsDrawingModalOpen}
          removeOrderItem={removeOrderItem}
          darkMode={darkMode}
          handleSubmit={handleSubmit} // 🔥 Itt adjuk át
          loading={loading}
          isProductModalOpen={isProductModalOpen} // 🔥 EZT ADD HOZZÁ!
          setOrderItems={setOrderItems} // 🔥 Ezt is kell, ha még nem adtad át!
          products={products}
          discountPercentage={discountPercentage}
          setDiscountPercentage={setDiscountPercentage}
          preferentialPrice={preferentialPrice}
          setPreferentialPrice={setPreferentialPrice}
          isAdvanceOrder={isAdvanceOrder}
          setIsAdvanceOrder={setIsAdvanceOrder}
          isGranitOnline={isGranitOnline}
          setIsGranitOnline={setIsGranitOnline}
          customerSource={customerSource}
          setCustomerSource={setCustomerSource}
        />

        {isProductModalOpen && (
          <ProductModal
            newProduct={newProduct}
            setNewProduct={setNewProduct}
            handleAddProduct={handleAddProduct}
            setIsProductModalOpen={setIsProductModalOpen}
            existingProducts={orderItems}
          />
        )}

        {/* <NewOrderDrawingModal
          isOpen={isDrawingModalOpen}
          onClose={() => setIsDrawingModalOpen(false)}
          drawingData={drawingData}
          setDrawingData={setDrawingData}
        /> */}
      </div>
    </div>
  ) : null;
};

export default NewOrderModal;
